module.exports = __webpack_public_path__ + "static/media/PagConstruccionMillSabores2.b567a114.png";